import { Outlet } from 'react-router';

import { ClubLayout } from '#src/components/profile/ClubLayout/index.tsx';

const UserTransactionsLayout = () => {
  return (
    <ClubLayout home>
      <Outlet />
    </ClubLayout>
  );
};

export default UserTransactionsLayout;
